export default __webpack_public_path__ + "static/fv-nr-2-311fa9052fa1b1a6e990c96b2c54c102.avif";